import * as React from 'react';

// utils
import { i18nService } from 'modules/language-provider/i18n.service';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { translate } from 'components/translate-hoc';
import { getRulesStatuses } from './invitation.utils';
import { getConjunctionType } from '../invitee/invitee.utils';
import { generateTranslationsKeyById } from '@sitegen/common/utils/translations';
// components
import { Icon, ICON_NAME } from 'components/icon';
// constants
import {
    TEXT_KEYS,
    GET_ANALYTICS_INVITATION_ACCEPT,
    GET_ANALYTICS_INVITATION_INIT_DATA
} from './invitation.constants';
import { INVITEE_PAGE_CAMPAIGN_DESCRIPTION_KEY } from '@sitegen/common/constants/translations';
import { TEXT_KEYS as TEXT_KEYS_INVITEE } from '../invitee/invitee.constants';
import { CONJUNCTION_TYPES } from '@sitegen/common/classes/friends-referral-api';
// styles
import './invitation.styles.less';
// types
import { IInvitationProps } from './invitation.types';
import { getModeClass } from 'utils/css';

export class Invitation extends React.Component<IInvitationProps> {
    private acceptInvitation = async () => {
        const joinButtonText = i18nService.getAnalyticsLabel(TEXT_KEYS.BUTTON_ACCEPT);
        AnalyticsService.sendFlowEvent(
            GET_ANALYTICS_INVITATION_ACCEPT(joinButtonText.toLowerCase())
        );
        return this.props.acceptInvitation();
    };

    public componentDidMount() {
        AnalyticsService.sendFlowEvent(GET_ANALYTICS_INVITATION_INIT_DATA());
    }

    public getConjunctionText = (conjunctionType: CONJUNCTION_TYPES) => {
        return conjunctionType === CONJUNCTION_TYPES.AND
            ? TEXT_KEYS_INVITEE.CONJUNCTION_AND_TEXT
            : TEXT_KEYS_INVITEE.CONJUNCTION_OR_TEXT;
    };

    public renderRulesDescription = (): JSX.Element[] => {
        const {
            conversion: { rules, conjunction },
            dangerouslyTranslateWithHTML: translateKey,
            dataFormat,
            shouldInheritStyles
        } = this.props;
        const statuses = getRulesStatuses(rules, dataFormat);
        const conjunctionType = getConjunctionType(conjunction);
        const conjunctionText = this.getConjunctionText(conjunctionType);
        const basePageStyleClass = getModeClass('sitegen-fr-invitation', shouldInheritStyles);
        return statuses.map((status, index) => (
            <div key={index} className={`${basePageStyleClass}__content-description`}>
                {translateKey(
                    generateTranslationsKeyById(INVITEE_PAGE_CAMPAIGN_DESCRIPTION_KEY, status.id),
                    { paramThreshold: status.paramThreshold }
                )}
                {index < statuses.length - 1
                    ? <div className={`${basePageStyleClass}__content-conjunction`}>
                        <div className="conjunction-text">
                            {translateKey(conjunctionText)}
                        </div>
                    </div>
                    : null
                }
            </div>
        ));
    };

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, invitationInfo, shouldInheritStyles } = this.props;
        const title = translateKey(TEXT_KEYS.TITLE);
        const description = translateKey(TEXT_KEYS.DESCRIPTION, {
            username: invitationInfo?.username,
            platform: invitationInfo?.platformId
        });
        const joinButtonText = translateKey(TEXT_KEYS.BUTTON_ACCEPT);
        const warningText = translateKey(TEXT_KEYS.WARNING);
        const basePageStyleClass = getModeClass('sitegen-fr-invitation', shouldInheritStyles);

        return (
            <div className={basePageStyleClass}>
                <div className={`${basePageStyleClass}__caption`}>
                    {translateKey(TEXT_KEYS.CAPTION)}
                </div>
                <h2 className={`${basePageStyleClass}__title`}>{title}</h2>
                <div className={`${basePageStyleClass}__content`}>
                    <div className={`${basePageStyleClass}__content-title`}>{description}</div>
                    {this.renderRulesDescription()}
                    <button onClick= {this.acceptInvitation} className={`${basePageStyleClass}__accept`}>
                        {joinButtonText}
                    </button>
                    <div className={`${basePageStyleClass}__warning`}>
                        <Icon name={ICON_NAME.WARNING} />
                        {warningText}
                    </div>
                </div>
            </div>
        );
    }
}

export const InvitationWithTranslations = translate()(Invitation);
